import { Squad } from '@core/models/squad';
import { createReducer, on } from '@ngrx/store';
import { FinishCustomerSquad, GetCustomerSquad } from './customer.actions';

export interface CustomerState {
  squad: Squad;
}

export const initialCustomerState: CustomerState = {
  squad: {},
};

export const customerReducer = createReducer(
  initialCustomerState,
  on(GetCustomerSquad, (state) => {
    return {
      ...state,
    };
  }),
  on(FinishCustomerSquad, (state, { squad }) => {
    return {
      ...state,
      squad,
    };
  })
);
